import CwPdfSelectView from "./index.vue"

export default CwPdfSelectView